<template>
  <div class="w-100">
    <div class="w-100" v-if="name === 'identification'">
      <router-link class="w-100" :to="{ name: 'kyc/verify-id-card' }">
        <DocumentItem :document="document" :type="'DOCUMENT'"></DocumentItem>
      </router-link>
    </div>
    <div class="w-100" v-else>
      <file-upload class="w-100"
                  :inputId="name"
                  ref="upload"
                  :extensions="['jpg', 'jpeg', 'png']"
                  v-model="document.files"
                  @input-file="inputFile"
                  @input-filter="inputFilter"
                  v-if="document">
        <DocumentItem :document="document" :type="'DOCUMENT'"></DocumentItem>
      </file-upload>
    </div>
  </div>
</template>

<script>
import DocumentItem from './DocumentItem'
import contractsApi from '@/api/now/contractsApi'

export default {
  name: 'DocumentImageItem',
  components: {
    DocumentItem
  },
  props: {
    name: { type: String },
    document: { type: Object }
  },
  data: function () { return {} },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    // Input Function Section
    inputFile: function (newFile, oldFile, document) {
      if (!newFile) { return }
      this.patchDocument(newFile)
    },
    inputFilter: function (newFile, oldFile, prevent) {
      // Create a blob field
      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    },
    // Patch Function Section
    async patchDocument(file) {
      if (!file.file) return
      let formdata = new FormData()
      formdata.append(this.name, file.file)
      let { data } = await contractsApi.patchDocuments(formdata)
      this.document.file = data[this.name]
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/design/_colors.scss';
.document a {
  color: $black;
}
</style>
